
import Vue from 'vue';
import { faCircleInfo, faCopy } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import { faLock } from '@delfi.lt/fa-kit/icons/modules/classic/regular';

interface cXWindow extends Window {
  [index: string]: any;
}
declare let window: cXWindow;

export default Vue.extend({
  props: {
    hasChannelSubscription: {
      type: Boolean,
      required: true,
    },
    customerToken: {
      type: String,
    },
  },
  data() {
    return {
      copiedIndex: null as number | null,
      demoResource: false,
      cards: [
        {
          class: 'gd',
          title: 'GERA DOVANA',
          image: 'https://static.delfi.lt/portal/images/customer/loyalty/gera_dovana.png',
          discount: '<strong>10% nuolaida</strong> visiems „Gera dovana“ dovanų rinkiniams',
          code: 'DOVANA10',
          conditions:
            '<strong>Naudojimo sąlygos:</strong><ul><li>Tapus prenumeratoriumi, suteikiama galimybė pasinaudoti „Gera dovana“ nuolaida dovanų rinkiniams.</li> <li>Nuolaidos kodas galioja el. parduotuvėje <a href="https://www.geradovana.lt" target="_blank">www.geradovana.lt</a></li> <li>Pirkimo metu suveskite nuolaidos kodą.</li><li>Nuolaidos nesumuojamos.</li></ul>',
          note: '<div><strong>Svarbu!</strong> Gruodžio mėnesį šis nuolaidos kodas negalioja.</div>',
          icon: faCircleInfo,
          link: 'https://shorturl.at/4H3Xj',
          buttonText: 'Panaudoti',
          event: 'loyalty_gera_dovana',
        },
        {
          class: 'af',
          title: 'AFFIDEA',
          image: 'https://static.delfi.lt/portal/images/customer/loyalty/affidea.png',
          discount: '<strong>20% nuolaida</strong> laboratoriniams tyrimams ir skiepams',
          code: 'DELFI20',
          conditions:
            '<strong>Naudojimo sąlygos:</strong><ul><li>Tapus prenumeratoriumi, suteikiama galimybė pasinaudoti „Affidea“ nuolaida visiems Laboratoriniams tyrimams ir skiepams.</li><li>Registruojantis vizitui privaloma informuoti apie turimą kodą. </li><li>Atvykus jį pateikite klientų aptarnavimo skyriaus darbuotojai.</li><li>Nepateikus darbuotojui kodo iki paslaugos suteikimo - nuolaida nebus taikoma.</li></ul>',
          note: '',
          link: 'https://bit.ly/4chhMbO',
          buttonText: 'Panaudoti',
          event: 'loyalty_affideda',
        },
        {
          class: 'wo',
          title: 'WOLT',
          image: 'https://static.delfi.lt/portal/images/customer/loyalty/wolt-plius.png',
          discount: 'Pirmieji 4 Wolt+ narystės mėnesiai – nemokamai',
          code: '',
          conditions:
            '<strong>Naudojimo sąlygos:</strong><ul><li>Tapus prenumeratoriumi, gaunate galimybę naudotis <i>Wolt+</i> naryste nemokamai net 4 mėnesius.</li><li>Paspauskite mygtuką „Panaudoti“ - būsite nukreipti į „Wolt“ programėlę, kur galėsite aktyvuoti pasiūlymą. </i></li><li>Nemokama Wolt+ narystė galios 4 mėnesius nuo aktyvavimo momento.</li></ul>',
          note: '<div class="text"><strong>Svarbu!</strong><div>Pasibaigus nemokamam laikotarpiui, automatiškai pradės galioti standartinė Wolt+ kainodara, jeigu narystė nebus atšaukta.</div><div>Pasiūlymas galioja tik vieną kartą vienam vartotojui ir negali būti perkeliamas ar keičiamas kitomis paslaugomis.</div></div>',
          icon: faCircleInfo,
          link: 'https://bit.ly/4chhMbO',
          buttonText: 'Panaudoti',
          buttonInfo: 'Paspauskite „Noriu!“ mygtuką ir atsiųsime aktyvavimo nuorodą į Jūsų el. paštą.',
          event: 'loyalty_wolt',
        },
        {
          class: 'pg',
          title: 'Pegasas',
          image: 'https://static.delfi.lt/portal/images/customer/loyalty/pegasas.png',
          discount: 'Pirmasis Pegaso prenumeratos mėnuo - nemokamai',
          code: ' ',
          conditions:
            '<strong>Naudojimo sąlygos:</strong><ul><li>Tapus prenumeratoriumi, gaunate pirmą mėnesį „Pegaso“ prenumeratos nemokamai.</li><li>Nukopijuokite unikalų Pegaso prenumeratos kodą.  </li><li>Tuomet paspauskite mygtuką „Panaudoti“ – būsite nukreipti į „Pegaso“ portalą, kuriame galėsite aktyvuoti prenumeratą.</li><li>Įveskite gautą kodą – pirmas mėnuo bus visiškai nemokamas.</li></ul>',
          note: '<div class="text"><strong>Svarbu!</strong><div>Pasibaigus nemokamam laikotarpiui, pradės galioti standartinė „Pegaso“ kainodara, jei prenumerata nebus atšaukta.</div><div>Pasiūlymas galioja tik vieną kartą vienam vartotojui ir negali būti perkeliamas ar keičiamas kitomis paslaugomis.</div></div>',
          icon: faCircleInfo,
          link: 'https://www.pegasas.lt/prenumerata#kodas',
          buttonText: 'Panaudoti',
          buttonInfo: 'Paspauskite „Noriu!“ mygtuką ir atsiųsime aktyvavimo nuorodą į Jūsų el. paštą.',
          event: 'loyalty_pegasas',
        },
      ],
      faCopy,
      faLock,
    };
  },
  methods: {
    async fetchLoyaltyCodes() {
      try {
        // WOLT
        const woltResponse = await fetch('https://paywall.delfi.lt/loyalty/WOLT', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.customerToken}`,
          },
        });

        if (woltResponse.ok) {
          const woltData = await woltResponse.json();
          const woltCard = this.cards.find((card) => card.title === 'WOLT');
          if (woltCard && woltData.link) {
            woltCard.link = woltData.link;
          }
        }

        // PEGASAS
        const pegasasResponse = await fetch('https://paywall.delfi.lt/loyalty/PEGASAS', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.customerToken}`,
          },
        });

        if (pegasasResponse.ok) {
          const pegasasData = await pegasasResponse.json();
          const pegasasCard = this.cards.find((card) => card.title === 'Pegasas');
          if (pegasasCard && pegasasData.code) {
            pegasasCard.code = pegasasData.code;
          }
        }
      } catch (error) {
        console.error('Failed to fetch loyalty codes:', error);
      }
    },
    async isDemoResource() {
      try {
        const resource = await fetch('https://paywall.delfi.lt/piano/check-demo-resource', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.customerToken}`,
          },
        });

        if (resource.ok) {
          const resourceData = await resource.json();
          this.demoResource = !!resourceData.isDemo;
        }
      } catch (error) {
        console.error('Failed to check demo resource:', error);
      }
    },
    copyCode(code: string, index: number) {
      if (!code || code.trim() === '') return;
      navigator.clipboard.writeText(code).then(() => {
        this.copiedIndex = index;
        setTimeout(() => {
          this.copiedIndex = null;
        }, 2000);
      });
    },
    logLoyaltyButtonClick(event: string) {
      if (window.cX && typeof window.cX.sendEvent === 'function') {
        window.cX.sendEvent(
          event,
          {
            user_id: this.$store.state.piano.profile.sub,
          },
          { origin: 'lth-delfi', persistedQueryId: '60134f11dac530e2cd5c308a42f829d82289a3b8' }
        );
      }
    },
  },
  mounted() {
    if (this.customerToken && this.hasChannelSubscription) {
      this.isDemoResource().then(() => {
        if (!this.demoResource) {
          this.fetchLoyaltyCodes();
        }
      });
    } else {
      this.$watch(
        () => [this.customerToken, this.hasChannelSubscription],
        async ([token, access]) => {
          if (token && access) {
            await this.isDemoResource();
            if (!this.demoResource) {
              this.fetchLoyaltyCodes();
            }
          }
        },
        { immediate: false, deep: false }
      );
    }
  },
});
